import { IAberrations } from '@ispm/aberrations/interfaces/aberrations.interface';

export class AberrationHandler {
  public static readonly UI_GENE_PROPERTY: string = 'ui_gene_text';

  static defineGeneHandler(aberration: IAberrations) {
    Reflect.defineProperty(aberration, AberrationHandler.UI_GENE_PROPERTY, {
      enumerable: false,
      configurable: true,
      value: handleGeneRepresentation(aberration)
    });
  }
}

function handleGeneRepresentation(target) {
  switch (target.AberrationClass.toUpperCase()) {
    case 'SNV':
      return target.HGNC_gene;
    case 'CNV':
      return target.gene;
    case 'FUSION':
      return `${target.gene_name1} - ${target.gene_name2} Fusion`;
  }
}
